export const STATUS_LABELS = {
	NOT_DISTRIBUTED: 'Not distributed',
	PENDING_DISTRIBUTION: 'Pending Distribution',
	ABORTED: 'Aborted',
	PARTIALLY_ABORTED: 'Partially aborted',
	ABORT_IN_PROGRESS: 'Abort in progress',
	IN_PROGRESS: 'In progress',
	COMPLETED: 'Completed',
	FAILED: 'Failed',
};

export const NODE_LICENSES = {
	VALID: 'VALID',
	NO_LICENSE: 'NO_LICENSE',
	EXPIRED: 'EXPIRED',
	DUPLICATED: 'DUPLICATED'
};

export const DISTRIBUTION_CONSTANTS = {
    DISTRIBUTION_STATUS: [
        {class: 'not-distributed', label: STATUS_LABELS.NOT_DISTRIBUTED, icon: 'icon-notif-warning', details:'Awaiting distribution'},
        {class: 'failed', label: STATUS_LABELS.ABORTED, icon: 'icon-notification-error', details:'Aborted by user'},
        {class: 'failed', label: STATUS_LABELS.PARTIALLY_ABORTED, icon: 'icon-notification-error', details:'Aborted by user'},
        {class: 'in-progress', label: STATUS_LABELS.PENDING_DISTRIBUTION, icon: 'icon-show-in-ci-server', details:'Awaiting distribution'},
        {class: 'in-progress', label: STATUS_LABELS.ABORT_IN_PROGRESS, icon: 'icon-show-in-ci-server', details:'Aborting distribution'},
        {class: 'in-progress', label: STATUS_LABELS.IN_PROGRESS, icon: 'icon-show-in-ci-server', details: ''},
        {class: 'completed', label: STATUS_LABELS.COMPLETED, icon: 'icon-notification-success', details: 'Distribution completed'},
        {class: 'failed', label: STATUS_LABELS.FAILED, icon: 'icon-notification-error', details: 'Error during distribution'}
    ],
    DISTRIBUTION_REFRESH_RATE: 5000,
    DISTRIBUTION_ACTIONS: {
        DISTRIBUTE: 'x',
        DELETE: 'd',
        READ: 'r',
        WRITE: 'w',
        MANAGE_PERMISSIONS: 'm'
    },
	BUNDLE_VERSION_DELETE_OPTIONS: {
        DELETE_GLOBALLY: 'globally',
        DELETE_LOCALLY: 'delete',
        DO_NOTHING: 'keep',
        ARCHIVE: 'archive',
    },
	DISTRIBUTION_TYPE: {
		DISTRIBUTE: 'Distribute',
		DELETE_RELEASE_BUNDLE_VERSION:'Delete'
    },
    PAIRING_STATUS: {
        INACTIVE: 'inactive'
    },
	BUNDLE_VERSION_STATES:  {
    	OPEN: 'OPEN',
		SIGNED: 'SIGNED',
        STORED: 'STORED',
        READY_FOR_DISTRIBUTION: 'READY_FOR_DISTRIBUTION'
    },
	BUNDLE_VERSION_STATE_LABELS: {
		OPEN: 'Not Signed',
		SIGNED: 'Signed',
        STORED: 'Stored',
        READY_FOR_DISTRIBUTION: 'Ready'
	},
	EDGE_NODE_LICENSES: {
    	TYPES: [
		    {name:'NONE', label:'No license', couldBeEdgeNode:false},
		    {name:'OSS',label:'Open source license', couldBeEdgeNode:false},
		    {name:'PRO',label:'Pro license', couldBeEdgeNode:false},
		    {name:'COMMERCIAL',label:'Commercial license', couldBeEdgeNode:false},
		    {name:'EDGE',label:'Edge node license', couldBeEdgeNode:true},
		    {name:'EDGE_TRIAL',label:'Edge node trial license',couldBeEdgeNode:true},
		    {name:'TRIAL',label:'Trial license', couldBeEdgeNode:false},
		    {name:'ENTERPRISE',label:'Enterprise license', couldBeEdgeNode:false},
		    {name:'ENTERPRISE_PLUS_TRIAL',label:'Enterprise Plus trial license', couldBeEdgeNode:true},
		    {name:'ENTERPRISE_PLUS',label:'Enterprise Plus license', couldBeEdgeNode:true},
	    ],
    	STATUSES: [
    		{name: NODE_LICENSES.VALID,label:'Valid license'},
		    {name: NODE_LICENSES.NO_LICENSE,label:'No license'},
		    {name: NODE_LICENSES.EXPIRED,label:'License expired'},
		    {name: NODE_LICENSES.DUPLICATED,label:'License duplicated'}
		 ]
	}
};



// WEBPACK FOOTER //
// ./modules/distribution/constants/distribution.constants.js